/**
 * SAML Configuration for Custom Reports Application
 * This file manages SAML authentication settings
 */

/**
 * SAML configuration settings
 */
export const samlConfig = {
    // Identity Provider (IdP) Configuration
    ssoUrl: process.env.REACT_APP_SAML_SSO_URL || 'https://your-idp.com/sso/saml',
    sloUrl: process.env.REACT_APP_SAML_SLO_URL || 'https://your-idp.com/slo/saml',
    idpEntityId: process.env.REACT_APP_SAML_IDP_ENTITY_ID || 'https://your-idp.com/metadata',
    
    // Service Provider (SP) Configuration - Our Application
    spEntityId: process.env.REACT_APP_SAML_SP_ENTITY_ID || 'https://localhost:3004',
    acsUrl: process.env.REACT_APP_SAML_ACS_URL || 'https://localhost:3004/saml/acs',
    spSloUrl: process.env.REACT_APP_SAML_SP_SLO_URL || 'https://localhost:3004/saml/slo',
    
    // Additional SAML settings
    nameIdFormat: 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
    signRequests: true,
    wantAssertionsSigned: true,
    validateSignature: true,

    // API Base URL
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL ,
};

/**
 * Get SAML SSO URL with parameters
 * @param {Object} relayState - Parameters to pass through the SAML flow
 * @returns {string} Complete SAML SSO URL
 */
export const getSamlSsoUrl = (relayState = {}) => {
    const params = new URLSearchParams({
        SAMLRequest: 'placeholder', // This will be generated by the server
        RelayState: JSON.stringify(relayState)
    });
    
    return `${samlConfig.ssoUrl}?${params.toString()}`;
};

/**
 * Validate SAML configuration
 * @returns {Object} Validation result with status and missing fields
 */
export const validateSamlConfig = () => {
    const requiredFields = [
        'ssoUrl',
        'idpEntityId',
        'spEntityId',
        'acsUrl'
    ];
    
    const missingFields = requiredFields.filter(field => 
        !samlConfig[field] || samlConfig[field].includes('your-idp.com')
    );
    
    return {
        isValid: missingFields.length === 0,
        missingFields,
        message: missingFields.length > 0 
            ? `Missing or incomplete SAML configuration: ${missingFields.join(', ')}`
            : 'SAML configuration is valid'
    };
};

/**
 * Get environment-specific configuration
 */
export const getEnvironmentConfig = () => {
    const isDevelopment = process.env.NODE_ENV === 'development';
    const isProduction = process.env.NODE_ENV === 'production';
    
    return {
        isDevelopment,
        isProduction,
        showDebugInfo: isDevelopment,
        enableDemoLogin: isDevelopment,
        logLevel: isDevelopment ? 'debug' : 'warn'
    };
};

export default samlConfig;
